import "./Edit_modal.css";

export function Edit_modal({ resetOptions, setResetOptions, onClose }) {
  return (
    <div className="modal_overlay">
      <div className="modal_box">
        <h3>Reset Status</h3>

        <label>
          <input
            type="checkbox"
            checked={resetOptions.h2h_Status}
            onChange={(e) =>
              setResetOptions((prev) => ({
                ...prev,
                h2h_Status: e.target.checked,
              }))
            }
          />
          H-2-H
        </label>

        <label>
          <input
            type="checkbox"
            checked={resetOptions.h2h_Away_Status}
            onChange={(e) =>
              setResetOptions((prev) => ({
                ...prev,
                h2h_Away_Status: e.target.checked,
              }))
            }
          />
          H-2-H-A
        </label>

        <label>
          <input
            type="checkbox"
            checked={resetOptions.h2h_Home_Status}
            onChange={(e) =>
              setResetOptions((prev) => ({
                ...prev,
                h2h_Home_Status: e.target.checked,
              }))
            }
          />
          H-2-H-H
        </label>

        <label>
          <input
            type="checkbox"
            checked={resetOptions.ratio_result}
            onChange={(e) =>
              setResetOptions((prev) => ({
                ...prev,
                ratio_result: e.target.checked,
              }))
            }
          />
          R_R
        </label>

        <label>
          <input
            type="checkbox"
            checked={resetOptions.compute_status}
            onChange={(e) =>
              setResetOptions((prev) => ({
                ...prev,
                compute_status: e.target.checked,
              }))
            }
          />
          compute_status
        </label>

        <div style={{ marginTop: "10px" }}>
          <button onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}
